import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import { createNotificationEmail, updateNotificationEmail } from '../../app/store/actions/notificationEmail';
import FIELDS from '../../data/fields';

class NotificationEmailForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      type: 'register',
      name: '',
      email: '',
      isEdit: false,
      isLoading: false,
      branchCode: '',
      messageErro: '',
      messageSuccess: '',
      notificationEmailId: null,
    };
  }

  componentDidMount() {
    if (this.props.back.location.selected) {
      this.selectedLine(this.props.back.location.selected);
    }
  }

  selectedLine = async (selected) => {
    const variablesToUpdate = {
      notificationEmailId: selected.id,
      email: selected.email,
      name: selected.name,
      isEdit: true,
    };

    if (this.props.notificationEmailTypeList.find(elements => elements.type === selected.type)) {
      variablesToUpdate.type = selected.type;
      variablesToUpdate.branchCode = '';
    } else {
      variablesToUpdate.type = 'getnetPayment';
      variablesToUpdate.branchCode = (selected.branch && selected.branch.id) ? selected.branch.id : '';
    }
    await this.setState(variablesToUpdate);
  }

  setValue = (att, value) => {
    this.setState({ [att]: value });
    if (att === 'type' && value !== 'getnetPayment') {
      this.setState({ branchCode: null });
    }
  }

  goBack = () => {
    this.props.back.goBack();
  };

  create = async () => {
    this.setState({ isLoading: true });
    const { email, name, type, branchCode, } = this.state;
    try {

      await this.props.createNotificationEmail({ email, name, type, branchCode })
      await this.setState({ messageSuccess: I18n.t('changeMade'), messageErro: '' });
      setTimeout(() => {
        this.goBack();
      }, 1000);
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error
      this.setState({ messageSuccess: '' })
      if (error && error.message) {
        const messageError = (error.code && error.details) ?
          `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({ messageErro: messageError })
      } else {
        this.setState({ messageErro: I18n.t('errorOcurred') })
      }
    }
    this.setState({ isLoading: false });
  }

  update = async () => {
    this.setState({ isLoading: true });
    const { notificationEmailId, email, name, type, branchCode, } = this.state;
    try {

      await this.props.updateNotificationEmail({ notificationEmailId, email, name, type, branchCode })
      await this.setState({ messageSuccess: I18n.t('registrationPerformed'), messageErro: '' });
      setTimeout(() => {
        this.goBack();
      }, 1000);
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error
      this.setState({ messageSuccess: '' })
      if (error && error.message) {
        const messageError = (error.code && error.details) ?
          `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({ messageErro: messageError })
      } else {
        this.setState({ messageErro: I18n.t('errorOcurred') })
      }
    }
    this.setState({ isLoading: false });
  }

  render() {
    const {
      isEdit, isLoading, email, name, type, branchCode,
      messageSuccess, messageErro,
    } = this.state;

    const { branchList, notificationEmailTypeList } = this.props;

    return (
      <div className="form-main">
        <h2 className="header-form-client">
          {I18n.t('notificationEmailRegistration')}
        </h2>
        <form>
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('email')}
            </p>
            <input
              type="email"
              onChange={e => this.setValue('email', e.target.value)}
              value={email}
              className="form-control"
              placeholder=""
              maxLength={FIELDS.max}
            />
          </div>

          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('name')}
            </p>
            <input
              type="text"
              onChange={e => this.setValue('name', e.target.value)}
              value={name}
              className="form-control"
              placeholder=""
              maxLength={FIELDS.max}
            />
          </div>

          <div className="form-group">
            <p className="margin-bottom-2">{I18n.t('type')}</p>
            <select
              onChange={e => this.setValue('type', e.target.value)}
              className="custom-select"
              value={type}
            >
              {notificationEmailTypeList.map(element => (
                <option key={element.type} value={element.type}>{I18n.t(`${element.name}`)}</option>
              ))}
            </select>
          </div>

          {type === 'getnetPayment' && (
            <div className="form-group">
              <p className="margin-bottom-2">{I18n.t('place')}</p>
              <select
                onChange={e => this.setValue('branchCode', e.target.value)}
                className="custom-select"
                value={branchCode}
              >
                <option key='' value=''>{''}</option>
                {branchList.map(element => (
                  <option key={element.id} value={element.id}>{element.crmTag}</option>
                ))}
              </select>
            </div>
          )}

          {!!messageSuccess && <p className="color-green margin-top-10">{messageSuccess}</p>}
          {!!messageErro && <p className="color-red margin-top-10">{messageErro}</p>}

          <div className="row margin-left-0 margin-top-10">
            <button
              type="button"
              onClick={() => this.goBack()}
              className="btn btn-warning margin-right-15"
            >
              {I18n.t('return')}
            </button>

            <button
              type="button"
              className="btn btn-dark"
              onClick={() => (isEdit ? this.update() : this.create())}
              disabled={isLoading}
            >
              {(!isEdit) ? I18n.t('save') : I18n.t('update')}
            </button>
          </div>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  createNotificationEmail: (parameters) => dispatch(createNotificationEmail(parameters)),
  updateNotificationEmail: (parameters) => dispatch(updateNotificationEmail(parameters)),
});

const mapStateToProps = state => ({
  branchList: state.notificationEmail.branchList,
  notificationEmailTypeList: state.notificationEmail.notificationEmailTypeList,
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationEmailForm);
